/** Shared feedback workflow labels. Legacy notes without a stored status are pending. */
export const FEEDBACK_STATUSES = [
  { value: 'pending', label: 'Pending' },
  { value: 'in-progress', label: 'In progress' },
  { value: 'ready-for-review', label: 'Ready for review' },
  { value: 'completed', label: 'Completed' },
] as const;

export type FeedbackStatus = (typeof FEEDBACK_STATUSES)[number]['value'];

export function getFeedbackStatus(value: unknown): FeedbackStatus {
  const key =
    typeof value === 'string' || Object.prototype.toString.call(value) === '[object String]'
      ? String(value)
      : undefined;
  return FEEDBACK_STATUSES.find(status => status.value === key)?.value ?? 'pending';
}
